module.exports = __webpack_public_path__ + "static/media/iGOLogo.a0726e95.png";